import React, { Component } from 'react';

//styles
import './sectionFive.scss';
import '../../static/fonts/Rubik/stylesheet.css'
import { fpInit } from '../../static/player'
import HolaPlayer from '../HolaPlayer/HolaPlayer.jsx'

class SectionFour extends Component {
    
    componentDidMount() {
        // this.initVideo({
        //     videoId: "2",
        //     mainUrl: "https://mediadownload.ynet.co.il/cdnwiz/1018/041018_nadlan_with_sub_fix2_8MRwHmBx_1600.mp4",
        //     poster: "./static/images/v2.png",
        //     selector: "#vid2"
        // })
    }

    initVideo(details) {
        fpInit(details);
    }

    render() {
        return (
            <div id="section5" className="section5-container">
                {/* <div className="image"></div> */}
                <div className="desc-container">
                    <div className="title">ואני? בניתי בית בארץ ישראל?</div>
                    <div className="desc">מהן המהמורות שעומדות בדרכו של זוג או משפחה בשאיפתם לקנות בית בארץ, מה החלופות האפשרויות  - שכירות? דיור ציבורי? והיכן אנו עומדים בהשוואה לעולם?</div>
                    <div className="image">
                        <div className="p-container">
                            {/* <div id="vid2" /> */}
                            <HolaPlayer
                                id={"vid2"}
                                poster={"./static/images/v2.png"}
                                src={"https://mediadownload.ynet.co.il/cdnwiz/1018/041018_nadlan_with_sub_fix2_8MRwHmBx_1600.mp4"}
                                title={"ואני? בניתי בית בארץ ישראל?"}
                            />
                            {/* <FlowPlayer poster={"./static/images/v2.png"}
                                VideoURL="https://mediadownload.ynet.co.il/cdnwiz/1018/041018_nadlan_with_sub_fix2_8MRwHmBx_1600.mp4" ID="2" /> */}
                            <div className="credit-container">
                                <div className="video-credit">
                                    כתבתן של בילי פרנקל ושלומית שרביט ברזילי
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="line"></div>
            </div>
        );
    }
}

export default SectionFour;


// WEBPACK FOOTER //
// ./src/Components/SectionFive/SectionFive.js